
export { CollectionName } from "/codebuild/output/src4237389316/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"